import { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RoutesAdmin from "../routes/admin/Routes";

export const ApplicationContext = createContext();

export const ApplicationProvider = ({ children }) => {
  const [selectedApplication, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const selectApplication = (application) => {
    setApplication(application);
    sessionStorage.setItem("selectedApplication", JSON.stringify(application));
    setLoading(false);
  };

  const removeApplication = () => {
    setApplication(null);
    sessionStorage.removeItem("selectedApplication");
    navigate("/aplicacoes");
  };

  useEffect(() => {
    const savedApplication = sessionStorage.getItem("selectedApplication");

    const isAdminRoute = Object.values(RoutesAdmin)
      .flat()
      .some((route) =>
        window.location.pathname.startsWith(route.path.replace(/:\w+/g, "")),
      );

    if (savedApplication) {
      try {
        const application = JSON.parse(savedApplication);
        setApplication(application);
        setLoading(false);
      } catch (error) {
        console.error("Erro ao carregar a aplicação do localStorage:", error);
        setLoading(false);
      }
    } else {
      setLoading(false);
      if (!isAdminRoute) {
        navigate("/aplicacoes");
      }
    }
  }, []);

  return (
    <ApplicationContext.Provider
      value={{
        selectedApplication,
        selectApplication,
        removeApplication,
        loading,
      }}>
      {!loading && children}
    </ApplicationContext.Provider>
  );
};
